export default "__VITE_ASSET__CoWPsT6D__"